import { BrowserNotificationTable } from '../definitions/BrowserNotifications'

export class BrowserNotifications {
  /**
   * Holds a table of the browser notifications
   * for a given user.
   */
  notifications: BrowserNotificationTable = {}

  /**
   * This will get the browser notifications from localStorage
   *
   * This will be replaces with a service in the future to get the browser
   * notifications.
   */
  public async getBrowserNotifications(): Promise<void> {
    const jsonString = localStorage.getItem(`browser-notifications`)
    if (jsonString) {
      this.notifications = JSON.parse(jsonString)
    }
  }

  /**
   * Gets the current version for a particular key
   * @param name
   * @returns
   */
  public getVersion(name: string): number {
    return this.notifications[name]
  }

  /**
   * Checks to see if a version exists
   * @param name
   * @param value
   * @returns
   */
  public hasVersion(name: string, value: number): boolean {
    return this.notifications[name] === value
  }

  /**
   * Sets a particular version for a key
   * This will be replaces with a service call in the future
   * @param name
   * @param value
   */
  public async setVersion(name: string, value: number): Promise<void> {
    this.notifications[name] = value
    localStorage.setItem('browser-notifications', JSON.stringify(this.notifications))
  }
}
